import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Home Page Mission Card - slides from right with rotation
 */
export const animateHomeMissionCard = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const card = element.querySelector('[class*="section"]') || element;
    
    // Set initial state immediately to prevent flash
    if (card) {
      gsap.set(card, { opacity: 0, x: 100, rotation: -5 });
    }
    
    const timer = setTimeout(() => {
      if (card) {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        
        tl.to(card, {
          opacity: 1,
          x: 0,
          rotation: 0,
          duration: 1.2,
          ease: "power3.out",
        });
        
        ScrollTrigger.refresh();
      }
    }, 100);
    
    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger === ref.current || trigger.vars?.trigger === ref.current) {
          trigger.kill();
        }
      });
    };
  }
};

